import { TreeSelectProps } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import DimensionTreeSelect from './DimensionTreeSelect'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'

interface CtxDimensionTreeSelectProps extends TreeSelectProps {
  showHint?: boolean
  enableShiftClick?: boolean
}

const CtxDimensionTreeSelect = (props: CtxDimensionTreeSelectProps) => {
  const companyId = useSelector(contextCompanyIdSelector)
  return <DimensionTreeSelect {...props} companyId={companyId} />
}

export default CtxDimensionTreeSelect
